import { useIsMobile } from "../volleyball/context/mobileContext";
import MMADesktopDashboard from "./screens/MMADesktopDashboard";
import MMAMobileDashboard from "./screens/MMAMobileDashboard";

const MMADashboard = () => {
  const isMobile = useIsMobile();
  return isMobile ? <MMAMobileDashboard /> : <MMADesktopDashboard />;
};

export default MMADashboard;
